import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ToolBar from "./ToolBar";
import GridView from "./ContentViews/Grid";
import UploadFileView from "./ContentViews/UploadFile";
import LoadingView from "./ContentViews/Loading";
import { insertFile } from "../../../utils/Files";
import {
  getAll as getAllFiles,
  destroy as deleteById,
} from "../../../data/Files";
import FileTabBar from "../../Tabs/FileTabBar";
import FileTab from "../../Tabs/FileTab";

export default function Index(props) {
  let [registerFields, setRegisterFields] = useState([]);
  let [registerHeaders, setRegisterHeaders] = useState([]);
  let [screenHeight, setScreenHeight] = useState(window.innerHeight);
  let [files, setFiles] = useState([]);
  let [fileId, setFileId] = useState(0);
  let [loading, setLoading] = useState(true);
  let [accountInfo, setAccountInfo] = useState({});

  useEffect(() => {
    listAllFiles();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  const handleResize = () => {
    setScreenHeight(window.innerHeight);
  };

  const listAllFiles = async () => {
    let files = await getAllFiles();
    setFiles(files);
  };

  let handleUploadFile = async (e) => {
    const filename = e.target.files[0].name;
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      await insertFile(props.layoutId, filename, text);
      listAllFiles();
    };
    reader.readAsText(e.target.files[0]);
  };

  const handleClickAddFile = async () => {
    setFileId(0);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, 0);
  };

  const handleLoadFile = async (fileId, fileContent, fileName) => {
    setLoading(true);
    setFileId(fileId);

    localStorage.setItem("lastClickedLayout", props.layoutId);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, fileId);

    await generateFields(fileContent);
    await generateRegisterHeaders(fileContent);
    loadAccountInfo(fileContent);

    setLoading(false);
  };

  const handleDeleteFile = async (fileId) => {
    await deleteById(fileId);
    setFileId(0);
    listAllFiles();
  };

  const parseOFX = (ofxText) => {
    const transactions = [];
    const transactionBlocks = ofxText.split("<STMTTRN>");

    transactionBlocks.forEach((block) => {
      if (!block.includes("</STMTTRN>")) return;

      const getTag = (tag) => {
        const match = block.match(new RegExp(`<${tag}>(.*)`));
        return match ? match[1].split("<")[0].trim() : "";
      };

      transactions.push({
        date: getTag("DTPOSTED"),
        amount: getTag("TRNAMT"),
        type: getTag("TRNTYPE"),
        memo: getTag("MEMO"),
        name: getTag("NAME"),
        checknum: getTag("CHECKNUM"),
        dtuser: getTag("DTUSER"),
        refnum: getTag("REFNUM"),
        fitid: getTag("FITID"),
        currency: getTag("CURRENCY"),
      });
    });
    console.log(transactions);
    return transactions;
  };

  const generateFields = async (fileContent) => {
    setRegisterFields([]);
    let registerFields = [];

    const parsedOFX = parseOFX(fileContent);

    await Promise.all(
      parsedOFX &&
        parsedOFX.map(function (r, index) {
          let fields = {
            id: index,
            date: r.date || "",
            type: r.type || "",
            amount: r.amount || "",
            memo: r.memo || "",
            name: r.name || "",
            checknum: r.checknum || "",
            dtuser: r.dtuser || "",
            refnum: r.refnum || "",
            fitid: r.fitid || "",
            currency: r.currency || "",
          };

          registerFields = registerFields.concat(fields);
        }),
    );
    console.log(registerFields);
    setRegisterFields(registerFields);
  };

  const generateRegisterHeaders = async (fileContent, csvSettings) => {
    setRegisterHeaders([]);
    const parsedOFX = parseOFX(fileContent);

    let dateMaxLength = 0;
    let typeMaxLength = 0;
    let amountMaxLength = 0;
    let memoMaxLength = 0;
    let nameMaxLength = 0;
    let checknumMaxLength = 0;
    let dtuserMaxLength = 0;
    let refnumMaxLength = 0;
    let fitidMaxLength = 0;
    let currencyMaxLength = 0;

    await Promise.all(
      parsedOFX &&
        parsedOFX.map((item, index) => {
          dateMaxLength =
            item.date.length > dateMaxLength ? item.date.length : dateMaxLength;
          typeMaxLength =
            item.type.length > typeMaxLength ? item.type.length : typeMaxLength;
          amountMaxLength =
            item.amount.length > amountMaxLength
              ? item.amount.length
              : amountMaxLength;
          memoMaxLength =
            item.memo.length > memoMaxLength ? item.memo.length : memoMaxLength;
          nameMaxLength =
            item.name.length > nameMaxLength ? item.name.length : nameMaxLength;
          checknumMaxLength =
            item.checknum.length > checknumMaxLength
              ? item.checknum.length
              : checknumMaxLength;
          dtuserMaxLength =
            item.dtuser.length > dtuserMaxLength
              ? item.dtuser.length
              : dtuserMaxLength;
          refnumMaxLength =
            item.refnum.length > refnumMaxLength
              ? item.refnum.length
              : refnumMaxLength;
          fitidMaxLength =
            item.fitid.length > fitidMaxLength
              ? item.fitid.length
              : fitidMaxLength;
          currencyMaxLength =
            item.currency.length > currencyMaxLength
              ? item.currency.length
              : currencyMaxLength;
        }),
    );

    const columns = [
      {
        field: "date",
        headerName: "Date",
        type: "string",
        minWidth: dateMaxLength * 11,
      },
      {
        field: "fitid",
        headerName: "Fitid",
        type: "string",
        minWidth: fitidMaxLength * 11,
      },
      {
        field: "type",
        headerName: "Type",
        type: "string",
        minWidth: typeMaxLength * 11,
      },
      {
        field: "amount",
        headerName: "Amount",
        type: "number",
        minWidth: amountMaxLength * 11,
      },
      {
        field: "memo",
        headerName: "Memo",
        type: "string",
        minWidth: memoMaxLength * 11,
      },
      {
        field: "name",
        headerName: "Name",
        type: "string",
        minWidth: nameMaxLength * 11,
      },
      {
        field: "checknum",
        headerName: "Checknum",
        type: "string",
        minWidth: checknumMaxLength * 11,
      },
      {
        field: "dtuser",
        headerName: "Dtuser",
        type: "string",
        minWidth: dtuserMaxLength * 11,
      },
      {
        field: "refnum",
        headerName: "Refnum",
        type: "string",
        minWidth: refnumMaxLength * 11,
      },

      {
        field: "currency",
        headerName: "Currency",
        type: "string",
        minWidth: currencyMaxLength * 11,
      },
    ];

    setRegisterHeaders(columns);
  };

  const loadAccountInfo = (fileContent) => {
    const org = getTagValue(fileContent, "ORG");
    const bankId = getTagValue(fileContent, "BANKID");
    const fid = getTagValue(fileContent, "FID");
    const acctId = getTagValue(fileContent, "ACCTID");
    const branchId = getTagValue(fileContent, "BRANCHID");
    setAccountInfo({ org, bankId, fid, acctId, branchId });
  };

  function getTagValue(fileContent, tag) {
    const regex = new RegExp(`<${tag}>([^<]*)`, "i");
    const match = fileContent.match(regex);
    return match ? match[1].trim() : null;
  }

  return (
    <div
      component="main"
      style={{
        flexGrow: 1,
        overflow: "hidden",
      }}
      mt={4}
    >
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box
          sx={{
            marginTop: "40px",
            padding: 1,
            userSelect: "none",
          }}
        >
          <FileTabBar
            handleClickAddFile={handleClickAddFile}
            enableAddFileButton={fileId === 0}
          >
            {files &&
              files.map((item) => {
                return (
                  props.layoutId === item["layoutId"] && (
                    <>
                      <FileTab
                        item={item}
                        handleDeleteFile={handleDeleteFile}
                        selected={fileId === item.id}
                        handleAction={() =>
                          handleLoadFile(
                            item.id,
                            item.fileContent,
                            item.fileName,
                          )
                        }
                      />
                    </>
                  )
                );
              })}
          </FileTabBar>
          {fileId > 0 && <ToolBar accountInfo={accountInfo}></ToolBar>}
        </Box>

        {loading && fileId !== 0 && <LoadingView />}

        {fileId > 0 &&
          !loading &&
          props.layoutId ===
            parseInt(localStorage.getItem("lastClickedLayout")) && (
            <>
              <GridView
                screenHeight={screenHeight}
                rows={registerFields}
                columns={registerHeaders}
              />
            </>
          )}
        {(fileId === 0 ||
          props.layoutId !==
            parseInt(localStorage.getItem("lastClickedLayout"))) && (
          <UploadFileView handleUploadFile={handleUploadFile} />
        )}
      </Box>
    </div>
  );
}
